import { Button, Stack } from "@mui/material";
import { useForm } from "react-hook-form";
import * as yup from 'yup';
import ReactPhoneInput from 'react-phone-input-material-ui';
import WushTextField from "../WushTextField";
import update from "../../../api/auth/customers/update";
import useCustomerStore from "../../../stores/useCustomerStore";
import useAlertStore from "../../../stores/useAlertStore";
import create from "../../../api/auth/customers/create";
import useYupValidationResolver from "../../../services/useYupValidationResolver";

const validationSchema = yup.object({
  first_name: yup.string().required("Required"),
  last_name: yup.string().required("Required"),
  email: yup.string().email("Invalid email").required("Required")
});

export default function CustomerForm({ customer, afterUpdate, afterCreate, onCancel }) {
  const { updateCustomer, addCustomer } = useCustomerStore();
  const { setAlertMessage } = useAlertStore();

  const { register, handleSubmit, reset, setValue, formState } = useForm({
    defaultValues: {
      first_name: customer?.first_name,
      last_name: customer?.last_name,
    },
    resolver: useYupValidationResolver(validationSchema),
  });

  const onSubmit = (data) => {
    if(customer?.id) {
      update(customer.id, data, (response) => {
        updateCustomer(response);
        setAlertMessage("Customer updated successfully", "success");
        afterUpdate && afterUpdate(response);
      }, (error) => {
        console.log(error);
      });
    } else {
      create(data, (response) => {
        addCustomer(response);
        reset();
        afterCreate && afterCreate(response);
      }, (error) => {
        console.log(error);
      });
    }
  };

  return (
    <Stack>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Stack mb={2}>
          <WushTextField formRegistration={register("first_name")} formState={formState} label="First Name" defaultValue={customer?.name} />
        </Stack>
        <Stack mb={2}>
          <WushTextField formRegistration={register("last_name")} formState={formState} label="Last Name" defaultValue={customer?.description} multiline />
        </Stack>
        <Stack mb={2}>
          <WushTextField formRegistration={register("email")} formState={formState} label="Email" defaultValue={customer?.email} multiline />
        </Stack>
        <Stack mb={2}>
          <ReactPhoneInput
            onChange={(phone) => setValue('phone', phone, { shouldDirty: true }) }
            value={customer?.phone}
            defaultCountry={'us'}
            country={'us'}
            countryCodeEditable={true}
            component={WushTextField}
            withCountryCallingCode={true}
            inputProps={{
              formState: formState,
            }}
          />
        </Stack>
        <Stack direction="row" spacing={2}>
          <Button disabled={!formState.isDirty || !formState.isValid} variant="contained" type="submit">{customer?.id ? "Update" : "Create"}</Button>
          {onCancel && <Button onClick={onCancel}>
            Cancel
          </Button>}
        </Stack>
      </form>
    </Stack>
  );
}